import axiosClient from "@/shared/lib/axios/axios.ts";
import { AxiosResponse } from "axios";
import { API_ROUTES } from "@/export/api/config.ts";
import {
  ReportsApiEnvelope,
  ReportJob,
  CreateJobRequest,
  ListJobsQueryParams,
  DownloadResponse,
  DownloadQueryParams,
} from "@/export/types/reports.ts";

// List Jobs - GET /api/reports/jobs
export const listReportJobs = async (
  params?: ListJobsQueryParams
): Promise<ReportsApiEnvelope<ReportJob[]>> => {
  return axiosClient
    .get<any, AxiosResponse<ReportsApiEnvelope<ReportJob[]>>>(
      `${API_ROUTES.REPORTS}jobs`,
      { params }
    )
    .then((res) => res.data);
};

// Create Job - POST /api/reports/job/new
export const createReportJob = async (
  request: CreateJobRequest
): Promise<ReportsApiEnvelope<ReportJob>> => {
  return axiosClient
    .post<any, AxiosResponse<ReportsApiEnvelope<ReportJob>>>(
      `${API_ROUTES.REPORTS}jobs/new`,
      request
    )
    .then((res) => res.data);
};

// Get Job Details - GET /api/reports/jobs/{job_id}
export const getReportJob = async (
  jobId: string
): Promise<ReportsApiEnvelope<ReportJob>> => {
  return axiosClient
    .get<any, AxiosResponse<ReportsApiEnvelope<ReportJob>>>(
      `${API_ROUTES.REPORTS}jobs/${jobId}`
    )
    .then((res) => res.data);
};

// Download Artifact - GET /api/reports/jobs/{job_id}/download
export const downloadReportArtifact = async (
  jobId: string,
  params?: DownloadQueryParams
): Promise<ReportsApiEnvelope<DownloadResponse>> => {
  return axiosClient
    .get<any, AxiosResponse<ReportsApiEnvelope<DownloadResponse>>>(
      `${API_ROUTES.REPORTS}jobs/${jobId}/download`,
      { params }
    )
    .then((res) => res.data);
};

